import { ContextMenuButton, Td, Tr } from 'app/components/Table';
import { ReactComponent as VerifiedIcon } from 'resources/images/verification-solid.svg';
import { MouseEvent } from 'react';
import { Row } from '@tanstack/react-table';
import { ListItemText } from 'app/components/ChakraTableList';
import { ContextMenuOption } from 'types/general.types';
import { Icon, Text } from '@chakra-ui/react';
import { IdType } from 'types/enums';

export type RowType = {
  type: IdType;
  number: number | string;
  verified: boolean;
  preferred: boolean;
  displayName: string;
  society?: string;
  options: ContextMenuOption[];
};

interface ProfileIdsTableRowProps {
  row: Row<RowType>;
  contextHandler: (e: MouseEvent<HTMLDivElement | HTMLButtonElement>) => void;
}

export const ProfileIdsTableRow = ({
  row,
  contextHandler,
}: ProfileIdsTableRowProps) => {
  const {
    type,
    number,
    verified,
    displayName,
    society,
    preferred,
  } = row.original;

  return (
    <Tr
      zIndex={1}
      position="relative"
      role="row"
      data-group
      hasAccessory={false}
      onContextMenu={contextHandler}
    >
      <Td position="relative">
        <ListItemText
          data-testid="id-number"
          primary={String(number)}
          primaryTextProps={{
            title: String(number),
          }}
          secondary={preferred ? 'Default' : ''}
          secondaryTextProps={{
            title: preferred ? 'Default' : '',
            fontSize: 'xs',
            color: 'textSubdued',
          }}
        />
      </Td>
      <Td>
        <ListItemText
          data-testid="id-type"
          primaryTextProps={{
            textTransform: 'uppercase',
          }}
          primary={type}
        />
      </Td>
      <Td>
        <ListItemText
          data-testid="id-display-name"
          primary={displayName}
          title={displayName}
        />
      </Td>
      <Td>
        <ListItemText
          data-testid="id-society"
          primaryTextProps={{
            display: 'inline-flex',
            w: 'full',
          }}
          primary={
            <>
              <Text
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                title={society}
              >
                {society}
              </Text>
              {verified && (
                <Icon
                  data-testid="verified"
                  as={VerifiedIcon}
                  title="Verified"
                  width={3}
                  height={3}
                  ml="4px"
                  my="auto"
                />
              )}
            </>
          }
        />
      </Td>
      <Td />
      <Td>
        <ContextMenuButton onClick={contextHandler} />
      </Td>
    </Tr>
  );
};
